/**
 * Request ID 管理工具
 * 從後端 Response Header 讀取 X-Request-ID，並在錯誤日誌中使用
 */

const REQUEST_ID_STORAGE_KEY = 'current_request_id';

/**
 * 儲存當前 Request ID
 */
export function setRequestId(requestId: string | null): void {
  if (requestId) {
    // 使用 sessionStorage 儲存（頁面關閉後清除）
    try {
      sessionStorage.setItem(REQUEST_ID_STORAGE_KEY, requestId);
    } catch (error) {
      // sessionStorage 可能不可用（如隱私模式），使用全域變數作為備援
      (window as any).__currentRequestId = requestId;
    }
  } else {
    // 清除 requestId
    try {
      sessionStorage.removeItem(REQUEST_ID_STORAGE_KEY);
    } catch {
      delete (window as any).__currentRequestId;
    }
  }
}

/**
 * 取得當前 Request ID
 */
export function getRequestId(): string | null {
  try {
    return (
      sessionStorage.getItem(REQUEST_ID_STORAGE_KEY) ||
      (window as any).__currentRequestId ||
      null
    );
  } catch {
    return (window as any).__currentRequestId || null;
  }
}

/**
 * 清除 Request ID
 */
export function clearRequestId(): void {
  setRequestId(null);
}
